var Diaporama = require("./Diaporama");
Diaporama.localize = require("./globals/localize");
module.exports = Diaporama;
